import { Dispatch } from "redux";
import { CourseTopicData } from "../../models/courseData";
import { courseTopicsService } from "../../api/index";

import {
  COURSE_TOPICS_REQUEST,
  COURSE_TOPICS_SUCCESS,
  COURSE_TOPICS_FAILURE,
  CourseTopicActionTypes,
  CourseTopicsRequestAction,
  CourseTopicsFailureAction,
  CourseTopicsSuccessAction,
} from "./types";

/**
 * Async action to fetch course topics.
 *
 * Dispatches a request action, then attempts to fetch course topics from the API.
 * If successful, dispatches success action with data.
 * If failed, dispatches failure action.
 *
 * @returns A thunk action for Redux.
 */
export const getCourseTopics = () => {
  return async (dispatch: Dispatch<CourseTopicActionTypes>) => {
    dispatch(courseTopicRequest());
    courseTopicsService
      .getCourseTopics()
      .then((response: CourseTopicData[]) => {
        dispatch(courseTopicSuccess(response));
      })
      .catch(() => {
        dispatch(courseTopicFailure());
      });
  };
};

/**
 * Action creator for successfully fetched course topics.
 *
 * @param data - Array of course topic objects.
 * @returns Action with type `COURSE_TOPICS_SUCCESS` and payload.
 */
export function courseTopicSuccess(data: CourseTopicData[]): CourseTopicsSuccessAction {
  return {
    type: COURSE_TOPICS_SUCCESS,
    data,
  };
}

/**
 * Action creator for initiating the course topics request.
 *
 * @returns Action with type `COURSE_TOPICS_REQUEST`.
 */
export function courseTopicRequest(): CourseTopicsRequestAction {
  return {
    type: COURSE_TOPICS_REQUEST,
  };
}

/**
 * Action creator for failed course topics request.
 *
 * @returns Action with type `COURSE_TOPICS_FAILURE`.
 */
export function courseTopicFailure(): CourseTopicsFailureAction {
  return {
    type: COURSE_TOPICS_FAILURE,
  };
}
